module.exports = __webpack_public_path__ + "img/MidSectionImage3.eafb093f.jpg";